module.exports = __webpack_public_path__ + "img/qrcode.1cc1fabd.png";